import { gql } from "@apollo/client";

export const lensCloudApp = gql`
    query lensCloudApp($lensId: ID!) {
        lensCloudApp(input: { lensId: $lensId }) {
            appId
        }
    }
`;
